<template>
  <div>
    <el-row>
      <!-- <el-col :span="16" :offset="6"> -->
      <el-col :span="20" :offset="2">
        <div>
          <el-container>
            <el-header style="height:40px;">
            </el-header>
            <el-container>
              <el-aside style="width:180px;">
                <el-row>
                  <el-col>
                    <el-menu router :default-active=$route.path class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                      <!-- <el-menu-item index="/ucenter/messcenter">
                        <i class="el-icon-bell"></i>
                        <span slot="title">消息中心</span>
                      </el-menu-item> -->
                      <el-menu-item index="/ucenter/practiceList">
                        <i class="el-icon-document"></i>
                        <span slot="title">训练项目</span>
                      </el-menu-item>
                      <el-menu-item index="/ucenter/practices">
                      <i class="el-icon-setting"></i>
                      <span slot="title">成绩中心</span>
                    </el-menu-item>
                      <!-- <el-menu-item index="/ucenter/examarrangement">
                        <i class="el-icon-setting"></i>
                        <span slot="title">考试安排</span>
                      </el-menu-item> -->
                      <el-menu-item index="/ucenter/examination">
                        <i class="el-icon-document-checked"></i>
                        <span slot="title">我的考试</span>
                      </el-menu-item>
                      <el-menu-item index="/ucenter/mytask">
                        <i class="el-icon-notebook-2"></i>
                        <span slot="title">我的作业</span>
                      </el-menu-item>
                          <!-- <el-menu-item index="/ucenter/theorylist">
                        <i class="el-icon-menu"></i>
                        <span slot="title">理论考核</span>
                      </el-menu-item> -->
                      <el-menu-item index="/ucenter/myInfo">
                        <i class="el-icon-menu"></i>
                        <span slot="title">个人中心</span>
                      </el-menu-item>

                      <!-- <el-menu-item index="/ucenter/changePassword">
                        <i class="el-icon-info"></i>
                        <span slot="title">修改密码</span>
                      </el-menu-item> -->
                    </el-menu>
                  </el-col>
                </el-row>

              </el-aside>
              <el-main>

                <router-view></router-view>
              </el-main>
            </el-container>
          </el-container>
        </div>
      </el-col>
    </el-row>

  </div>

</template>
<script>
export default {
  data() {
    return {
      isCollapse: true
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/UserCenter.vue